<template>
  <div
    style="
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <v-card class="mt-12" min-width="80%">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title
          >{{ $t("CERTIFICATE.certificate") }}
          {{ $t(translates[selectedTypeIndex]) }}</v-toolbar-title
        >
      </v-toolbar>
      <v-tabs vertical left class="my-tabs">
        <v-tab
          v-for="(item, j) in types"
          :key="j"
          :id="`certificate-submit-${item}-tab`"
          @click="
            clear();
            selectedType = item;
            selectedTypeIndex = j;
          "
        >
          <v-icon left> {{ typeIcons[j] }} </v-icon>
          {{ $t(translates[j]) }}
        </v-tab>

        <!-- Authors -->
        <v-tab-item>
          <v-form ref="authorsCertificate">
            <v-card flat class="pa-6">
              <v-row>
                <v-text-field
                  outlined
                  dense
                  :label="$t('CERTIFICATE.certificateName')"
                  v-model="certificateName"
                  :rules="required"
                  required
                ></v-text-field>
              </v-row>
              <v-row>
                <v-select
                  :items="days"
                  v-model="day"
                  :label="$t('CERTIFICATE.day')"
                  required
                  disabled
                  :rules="required"
                  dense
                  outlined
                ></v-select>
              </v-row>
              <v-row>
                <v-text-field
                  outlined
                  dense
                  :label="$t('CERTIFICATE.authors.name')"
                  v-model="articleName"
                  :rules="required"
                  required
                ></v-text-field>
              </v-row>
              <v-row class="mb-8" align="center">
                <v-col v-if="selectedUsers.length != 0">
                  <v-list
                    class="ma-0 pa-0 custom-scroll"
                    style="width: 100%"
                  >
                    <v-list-item v-for="(user, i) in sortUsers(selectedUsers)" :key="i">
                      <v-list-item-avatar>
                        <v-icon large>{{ icon.mdiAccountCircle }}</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ user.displayName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{
                          user.email
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col v-else>
                  <div class="text--secondary">
                    {{$t('CERTIFICATE.no_users')}}
                  </div>
                </v-col>
                <v-col cols="1" align="center">
                  <v-dialog v-model="authorsDialog">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>
                          {{ icon.mdiAccountPlus }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-row style="padding: 0 10px; padding-top: 10px; margin: 0; width: 100%;">
                        <v-spacer></v-spacer>
                        <v-btn icon @click="authorsDialog = false">
                          <v-icon>
                            {{ icon.mdiClose }}
                          </v-icon>
                        </v-btn>
                      </v-row>
                      <select-users
                        :single-select="false"
                        @setSelectedUsers="addUsers"
                      />
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>

              <v-row justify="end" class="mx-5">
                <v-btn
                  id="author-certificates-send-button"
                  @click="sendCertificates()"
                  class="success"
                  >{{ $t("CERTIFICATE.send") }}</v-btn
                >
              </v-row>
            </v-card>
          </v-form>
        </v-tab-item>

        <!-- Chairs -->
        <v-tab-item>
          <v-form ref="chairsCertificate">
            <v-card flat class="pa-6">
              <v-row>
                <v-text-field
                  outlined
                  dense
                  :label="$t('CERTIFICATE.certificateName')"
                  v-model="certificateName"
                  :rules="required"
                  required
                ></v-text-field>
              </v-row>
              <v-row>
                <v-text-field
                  outlined
                  dense
                  label="Track Name"
                  v-model="trackName"
                  :rules="required"
                  required
                ></v-text-field>
              </v-row>
              <v-row>
                <v-select
                  :items="days"
                  v-model="day"
                  :label="$t('CERTIFICATE.day')"
                  required
                  disabled
                  :rules="required"
                  dense
                  outlined
                ></v-select>
              </v-row>
              <v-row class="mb-8" align="center">
                <v-col v-if="selectedUsers.length != 0">
                  <v-list
                    class="ma-0 pa-0 custom-scroll"
                    style="width: 100%"
                  >
                    <v-list-item v-for="(user, i) in sortUsers(selectedUsers)" :key="i">
                      <v-list-item-avatar>
                        <v-icon large>{{ icon.mdiAccountCircle }}</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ user.displayName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{
                          user.email
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col v-else>
                  <div class="text--secondary">
                    {{$t('CERTIFICATE.no_users')}}
                  </div>
                </v-col>
                <v-col cols="1" align="center">
                  <v-dialog v-model="chairsDialog">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>
                          {{ icon.mdiAccountPlus }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-row style="padding: 0 10px; padding-top: 10px; margin: 0; width: 100%;">
                        <v-spacer></v-spacer>
                        <v-btn icon @click="chairsDialog = false">
                          <v-icon>
                            {{ icon.mdiClose }}
                          </v-icon>
                        </v-btn>
                      </v-row>
                      <select-users
                        :single-select="false"
                        @setSelectedUsers="addUsers"
                      />
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>

              <v-row justify="end" class="mx-5">
                <v-btn
                  id="chairs-certificates-send-button"
                  @click="sendCertificates()"
                  class="success"
                  >{{ $t("CERTIFICATE.send") }}</v-btn
                >
              </v-row>
            </v-card>
          </v-form>
        </v-tab-item>

        <!-- Speaker -->
        <v-tab-item>
          <v-form ref="speakerCertificate">
            <v-card flat class="pa-6">
              <v-row>
                <v-text-field
                  outlined
                  dense
                  :label="$t('CERTIFICATE.certificateName')"
                  v-model="certificateName"
                  :rules="required"
                  required
                ></v-text-field>
              </v-row>
              <v-row>
                <v-select
                  :items="days"
                  v-model="day"
                  :label="$t('CERTIFICATE.day')"
                  required
                  disabled
                  :rules="required"
                  dense
                  outlined
                ></v-select>
              </v-row>
              <v-row>
                <v-text-field
                  required
                  outlined
                  dense
                  v-model="speakName"
                  :rules="required"
                  :label="$t('CERTIFICATE.speaker.name')"
                ></v-text-field>
              </v-row>
              <v-row class="mb-8" align="center">
                <v-col v-if="selectedUsers.length != 0">
                  <v-list
                    class="ma-0 pa-0 custom-scroll"
                    style="width: 100%"
                  >
                    <v-list-item v-for="(user, i) in sortUsers(selectedUsers)" :key="i">
                      <v-list-item-avatar>
                        <v-icon large>{{ icon.mdiAccountCircle }}</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ user.displayName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{
                          user.email
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col v-else>
                  <div class="text--secondary">
                    {{$t('CERTIFICATE.no_users')}}
                  </div>
                </v-col>
                <v-col cols="1" align="center">
                  <v-dialog v-model="speakersDialog">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>
                          {{ icon.mdiAccountPlus }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-row style="padding: 0 10px; padding-top: 10px; margin: 0; width: 100%;">
                        <v-spacer></v-spacer>
                        <v-btn icon @click="speakersDialog = false">
                          <v-icon>
                            {{ icon.mdiClose }}
                          </v-icon>
                        </v-btn>
                      </v-row>
                      <select-users
                        :single-select="false"
                        @setSelectedUsers="addUsers"
                      />
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>

              <v-row justify="end" class="mx-5">
                <v-btn
                  id="speaker-certificates-send-button"
                  @click="sendCertificates()"
                  class="success"
                  >{{ $t("CERTIFICATE.send") }}</v-btn
                >
              </v-row>
            </v-card>
          </v-form>
        </v-tab-item>

        <!-- Participant -->
        <v-tab-item>
          <v-form ref="participantCertificate">
            <v-card flat class="pa-6">
              <v-row>
                <v-text-field
                  outlined
                  dense
                  :label="$t('CERTIFICATE.certificateName')"
                  v-model="certificateName"
                  :rules="required"
                  required
                ></v-text-field>
              </v-row>
              <v-row>
                <v-select
                  :items="days"
                  v-model="day"
                  :label="$t('CERTIFICATE.day')"
                  required
                  disabled
                  :rules="required"
                  dense
                  outlined
                ></v-select>
              </v-row>
              <v-row class="mb-8" align="center">
                <v-col v-if="selectedUsers.length != 0">
                  <v-list
                    class="ma-0 pa-0 custom-scroll"
                    style="width: 100%"
                  >
                    <v-list-item v-for="(user, i) in sortUsers(selectedUsers)" :key="i">
                      <v-list-item-avatar>
                        <v-icon large>{{ icon.mdiAccountCircle }}</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ user.displayName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{
                          user.email
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col v-else>
                  <div class="text--secondary">
                    {{$t('CERTIFICATE.no_users')}}
                  </div>
                </v-col>
                <v-col cols="1" align="center">
                  <v-dialog v-model="participantsDialog">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>
                          {{ icon.mdiAccountPlus }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-row style="padding: 0 10px; padding-top: 10px; margin: 0; width: 100%;">
                        <v-spacer></v-spacer>
                        <v-btn icon @click="participantsDialog = false">
                          <v-icon>
                            {{ icon.mdiClose }}
                          </v-icon>
                        </v-btn>
                      </v-row>
                      <select-users
                        :single-select="false"
                        @setSelectedUsers="addUsers"
                        :isParticipant="true"
                      />
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>

              <v-row justify="end" class="mx-5">
                <v-btn
                  id="participant-certificates-send-button"
                  @click="sendCertificates()"
                  class="success"
                  >{{ $t("CERTIFICATE.send") }}</v-btn
                >
              </v-row>
            </v-card>
          </v-form>
        </v-tab-item>

        <!-- Course -->
        <v-tab-item>
          <v-form ref="courseCertificate">
            <v-card flat class="pa-6">
              <v-row>
                <v-text-field
                  outlined
                  dense
                  :label="$t('CERTIFICATE.certificateName')"
                  v-model="certificateName"
                  :rules="required"
                  required
                ></v-text-field>
              </v-row>
              <v-row>
                <v-select
                  :items="days"
                  v-model="day"
                  :label="$t('CERTIFICATE.day')"
                  required
                  disabled
                  :rules="required"
                  dense
                  outlined
                ></v-select>
              </v-row>
              <v-row>
                <v-text-field
                  required
                  outlined
                  dense
                  :rules="required"
                  v-model="courseName"
                  :label="$t('CERTIFICATE.course.name')"
                ></v-text-field>
              </v-row>
              <v-row>
                <v-text-field
                  required
                  outlined
                  dense
                  :rules="required"
                  v-model="hours"
                  :label="$t('CERTIFICATE.course.hours')"
                ></v-text-field>
              </v-row>
              <v-row class="mb-8" align="center">
                <v-col v-if="selectedUsers.length != 0">
                  <v-list
                    class="ma-0 pa-0 custom-scroll"
                    style="width: 100%"
                  >
                    <v-list-item v-for="(user, i) in sortUsers(selectedUsers)" :key="i">
                      <v-list-item-avatar>
                        <v-icon large>{{ icon.mdiAccountCircle }}</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ user.displayName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{
                          user.email
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col v-else>
                  <div class="text--secondary">
                    {{$t('CERTIFICATE.no_users')}}
                  </div>
                </v-col>
                <v-col cols="1" align="center">
                  <v-dialog v-model="coursesDialog">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>
                          {{ icon.mdiAccountPlus }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-row style="padding: 0 10px; padding-top: 10px; margin: 0; width: 100%;">
                        <v-spacer></v-spacer>
                        <v-btn icon @click="coursesDialog = false">
                          <v-icon>
                            {{ icon.mdiClose }}
                          </v-icon>
                        </v-btn>
                      </v-row>
                      <select-users
                        :single-select="false"
                        @setSelectedUsers="addUsers"
                      />
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>

              <v-row justify="end" class="mx-5">
                <v-btn
                  id="course-certificates-send-button"
                  @click="sendCertificates()"
                  class="success"
                  >{{ $t("CERTIFICATE.send") }}</v-btn
                >
              </v-row>
            </v-card>
          </v-form>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <v-snackbar
      v-model="snackbar.show"
      top
      right
      :timeout="4000"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import {
  mdiAccountCircle,
  mdiAccountGroup,
  mdiSeat,
  mdiAccountTieVoice,
  mdiAccount,
  mdiFileCertificateOutline,
  mdiClose,
  mdiAccountPlus,
} from "@mdi/js";
import SelectUsers from "../../components/atoms/SelectUsers.vue";

export default {
  components: { SelectUsers },
  data: () => ({
    icon: {
      mdiAccountCircle,
      mdiAccountGroup,
      mdiSeat,
      mdiAccountTieVoice,
      mdiAccount,
      mdiFileCertificateOutline,
      mdiClose,
      mdiAccountPlus,
    },
    dialog: false,
    day: "10",
    days: ["08", "09", "10"],
    required: [(v) => !!v || "Required"],
    selectedType: "authors",
    selectedTypeIndex: 0,
    types: ["authors", "chairs", "speaker", "participant", "course"],
    translates: [
      "CERTIFICATE.types.authors",
      "CERTIFICATE.types.chairs",
      "CERTIFICATE.types.speaker",
      "CERTIFICATE.types.participant",
      "CERTIFICATE.types.course",
    ],
    selectedUser: null,
    selectedUsers: [],
    articleName: "",
    speakName: "",
    courseName: "",
    hours: "",
    certificateName: "",
    authorsDialog: false,
    chairsDialog: false,
    speakersDialog: false,
    participantsDialog: false,
    coursesDialog: false,
    trackName: "",
  }),
  methods: {
    getNameEmail(name, email) {
      return `${name} (${email})`;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    sortUsers(users) {
      return [...users].sort((u1, u2) =>
        u1.displayName.toLowerCase() < u2.displayName.toLowerCase() ? -1 : 1);
    },
    removeUser(user) {
      this.selectedUsers.splice(user, 1);
    },
    addUsers(users) {
      let userList = [];

      users.forEach((e) =>
        userList.push({
          id: e.id,
          displayName: e.displayName,
          email: e.email,
        })
      );

      this.selectedUsers = userList;
    },
    getCertificatesPayload() {
      var certificates = [];
      var data;

      switch (this.selectedType) {
        case "authors":
          data = {
            authors: this.selectedUsers,
            articleName: this.articleName,
          };
          break;

        case "chairs":
          data = {
            collaborators: this.selectedUsers,
            chairs: [`${this.trackName}`],
          };
          break;

        case "speaker":
          data = {
            speakName: this.speakName,
          };
          break;

        case "participant":
          data = {};
          break;

        case "course":
          data = {
            courseName: this.courseName,
            authors: this.selectedUsers,
            courseHours: this.hours,
          };
          break;
      }

      this.selectedUsers.forEach((user) => {
        certificates.push({
          url: "certificate url",
          user: user,
          certificateName: this.certificateName,
          data: data,
          type: this.selectedType,
          date: this.day,
          generated: false,
        });
      });

      this.selectedUsers = [];

      return certificates;
    },
    clear() {
      this.$refs[`${this.selectedType}Certificate`].resetValidation();
      this.selectedUser = undefined; //clear autocomplete
      this.selectedUsers = [];
      this.certificates = [];
      this.hours = "";
      this.certificateName = "";
      this.articleName = "";
      this.courseName = "";
      this.speakName = "";
      this.$refs[`${this.selectedType}Certificate`].resetValidation();
    },
    sendCertificates() {
      var payload = this.getCertificatesPayload();
      if (this.$refs[`${this.selectedType}Certificate`].validate()) {
        if (this.$store.dispatch("sendCertificate", payload)) {
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Success on send Certificate!",
            color: "success",
          });
          this.clear();
        } else {
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Oops... Error on send Certificate",
            color: "error",
          });
        }
      }
    },
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar.snackbar;
    },
    typeIcons() {
      return [
        this.icon.mdiAccountGroup,
        this.icon.mdiSeat,
        this.icon.mdiAccountTieVoice,
        this.icon.mdiAccount,
        this.icon.mdiFileCertificateOutline,
      ];
    },
    users() {
      return this.$store.getters.getUsers || [];
    },
  },
  created() {
    if (!this.$store.getters.getUsers) {
      this.$store.dispatch("getAllUsers");
    }
  },
};
</script>

<style scoped>
.custom-title {
  color: rgb(114, 114, 114);
  font-size: 130%;
  font-weight: 500;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
.custom-scroll {
  max-height: 300px;
  overflow: auto;
}
/* width */
.custom-scroll::-webkit-scrollbar {
  width: 5px;
}
/* Track */
.custom-scroll::-webkit-scrollbar-track {
  background: none;
}
/* Handle */
.custom-scroll::-webkit-scrollbar-thumb {
  background: #ffcc4d;
  border-radius: 2px;
}
/* Handle on hover */
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #e2a814;
}
</style>